import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_THEME } from "../theme.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateThemeInput } from "../../../__generated__/globalTypes";
import {
  UpdateThemeMutation,
  UpdateThemeMutationVariables,
} from "../../../__generated__/UpdateThemeMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateTheme = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateThemeInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateThemeMutation,
    UpdateThemeMutationVariables
  >(UPDATE_THEME, {
    refetchQueries: ["ThemesQuery", "ThemeQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateTheme?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateTheme?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
